<!--
 * @,@Author: ,: your name
 * @,@Date: ,: 2020-12-14 09:38:09
 * @,@LastEditTime: ,: 2021-01-26 14:24:22
 * @,@LastEditors: ,: Please set LastEditors
 * @,@Description: ,: In User Settings Edit
 * @,@FilePath: ,: \mall-admin-web\src\components\Breadcrumb\index.vue
 -->
<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" >
        <template v-if="item.meta.title">
          <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
          <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
        </template>

      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      // console.log('路由',matched);
      const first = matched[0]
      let title='微析'
      if(this.projectName==='QYC'){
        title='微析'
      }else if(this.projectName==='YW'){
        title='甬微'
      }else if(this.projectName==='KYC'){
        title="微科"
      }else if(this.projectName==='WP'){
        title="微谱"
      }
      if (first && first.name !== 'home') {
        matched = [{ path: '/home', meta: { title: title+' - 首页' }}].concat(matched)
      }
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue